/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Resize controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { ResizeImageRequest, RequestOptions, EnqueueImageOperationResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ResizeService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    resize(resizeImageRequest: ResizeImageRequest, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    resize(resizeImageRequest: ResizeImageRequest, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    resize(resizeImageRequest: ResizeImageRequest, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    resize(resizeImageRequest: ResizeImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/resize`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: resizeImageRequest,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    resizeAsync(resizeImageRequest: ResizeImageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<EnqueueImageOperationResponse>;
    resizeAsync(resizeImageRequest: ResizeImageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EnqueueImageOperationResponse>>;
    resizeAsync(resizeImageRequest: ResizeImageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EnqueueImageOperationResponse>>;
    resizeAsync(resizeImageRequest: ResizeImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/resize/async`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: resizeImageRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
